export const filterPurpose = (list) => {
  const filter_1 = list.filter((filt) => {
    return filt.purposeCategoryId === 1;
  });

  const filter_2 = list.filter((filt) => {
    return filt.purposeCategoryId === 2;
  });

  const filter_3 = list.filter((filt) => {
    return filt.purposeCategoryId === 3;
  });

  const filter_4 = list.filter((filt) => {
    return filt.purposeCategoryId === 4;
  });

  const filter_5 = list.filter((filt) => {
    return filt.purposeCategoryId === 5;
  });

  const filter_6 = list.filter((filt) => {
    return filt.purposeCategoryId === 6;
  });

  return [filter_1, filter_2, filter_3, filter_4, filter_5, filter_6];
};

export const titlePurposeES = [
  "Desarrollo personal",
  "Remuneración, Beneficios y Reconomiento",
  "Tipo de Trabajo",
  "Industria y Empresa",
  "Dinámica laboral",
  "Personal",
];

export const titlePurposeBR = [
  "Desenvolvimento Pessoal",
  "Remuneração, Benefícios e Reconhecimento",
  "Tipo de Trabalho",
  "Indústria e Empresa",
  "Dinâmica de Trabalho",
  "Pessoal",
];
